import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { messagingApi, type DLQMessage } from '../../api/messaging';
import { eventPlatformApi, type DeadLetterRecord } from '../../api/eventplatform';

export function DeadLetterViewerPage() {
  const [records, setRecords] = useState<(DLQMessage | DeadLetterRecord)[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void messagingApi.listDLQ({ limit: 100 })
      .then((r) => setRecords(r.messages))
      .catch(() =>
        eventPlatformApi.deadLetter().then((r) => setRecords(r.records)).catch((e) => setError(String(e))),
      );
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/events" className="text-sm text-blue-600 hover:underline dark:text-blue-400">← Event Hub</Link>
      <Link to="/events/messaging" className="ml-4 text-sm text-blue-600 hover:underline dark:text-blue-400">Full Reliability Console →</Link>
      <h1 className="mt-2 text-2xl font-semibold">Dead Letter Viewer</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">DEV-000060 — enterprise DLQ with failure classification.</p>
      {error && <p className="mt-4 text-sm text-red-600 dark:text-red-400">{error}</p>}
      <ul className="mt-6 space-y-2">
        {records.length === 0 && <li className="text-sm text-slate-500">No dead letter records.</li>}
        {records.map((r) => {
          const name = 'event_name' in r ? r.event_name : r.event_name;
          const err = 'failure_reason' in r ? r.failure_reason : r.error;
          const key = 'id' in r ? r.id : r.event_id + ('at' in r ? r.at : '');
          const cat = 'failure_category' in r ? r.failure_category : undefined;
          return (
            <li key={key} className="rounded border px-4 py-3 dark:border-slate-700">
              <span className="font-mono">{name}</span>
              {cat && <span className="ml-2 rounded bg-slate-100 px-1.5 text-xs dark:bg-slate-800">{cat}</span>}
              <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">{err}</p>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
